import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Voordat u een melding doet, is het noodzakelijk dat u even onderzoekt of u melding terecht is. Is er bijvoorbeeld onvoldoende onderhoud gepleegd of misschien is de garantieperiode verlopen? Bekijk hiervoor de "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/docs/Procedure_Nazorg.pdf",
    target: "_blank"
  }, "procedure nazorg"),
  /*#__PURE__*/_createTextVNode(" om te beoordelen of u een terechte melding indient.")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Heeft u de handleiding(en) bij de documenten al bekeken? Wellicht vindt u daar eenvoudig en snel een antwoord op uw vraag.", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "no-mb" }, "Bij meerdere klachten, graag ieder gebrek afzonderlijk melden voor een correcte verwerking in ons systeem.", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", null, "Contactgegevens", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Onderstaande contactgegevens zullen worden gebruikt voor de behandeling van deze vraag. Pas aan indien nodig.", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Contactpersoon "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Telefoonnummer "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("E-mailadres "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", null, "Details", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Bouwnummer "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Ruimte "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Onderdeel "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Onderwerp "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Omschrijving "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Afbeeldingen "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Voorwaarden "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f38929"} }, "*")
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, "Voor het oplossen van uw klacht is het noodzakelijk dat er een afspraak met u gemaakt wordt. Deze afspraak wordt gemaakt door de klacht oplossende onderaannemer of leverancier. Het is dan ook noodzakelijk dat u ons toestemming geeft voor de verstrekking van uw gegevens aan de klacht oplossende onderaannemer of leverancier.", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("a", {
  href: "/docs/Privacyverklaring_Thunnissen_Oktober_2019.pdf",
  target: "_blank"
}, "privacybeleid", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("a", {
  href: "/docs/Woonon_Procedure_Nazorg_05_2024.pdf",
  target: "_blank"
}, "de procedure service & nazorg", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Velden gemarkeerd met een "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f38929"} }, "*"),
  /*#__PURE__*/_createTextVNode(" zijn verplicht.")
], -1)

import { useRoute, useRouter } from 'vue-router'
import { issueStore } from '@/stores/issue'
import TextEditor from '@/components/service/TextEditor.vue'
import Uploader from '@/components/service/Uploader.vue'
import UploadQueue from '@/components/service/UploadQueue.vue'
import { computed, onMounted, ref } from 'vue'
import { authStore } from '@/stores/auth'
import { NewIssue } from '@/types/service/issue'
import { generalStore } from '@/stores/general'
import axios from 'axios'


export default /*#__PURE__*/_defineComponent({
  __name: 'IssueCreate',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const buildings = ref([])

const issue = ref<NewIssue>({
  title: null,
  body: null,
  building_id: null,
  room_id: null,
  element_id: null,
  contact_name: authStore().user.fullname ?? null,
  contact_phone: authStore().user.phonenumber ?? null,
  contact_email: authStore().user.email ?? null,
  files: [],
  type: 1
})

const agreeWithTerms = ref(false)
const agreeWithProcedure = ref(false)

const requiredFieldsCompleted = computed(() => {
  const minimalRequired = !!(issue.value.title && issue.value.body && issue.value.contact_name && issue.value.contact_email && issue.value.contact_phone && issue.value.files.length && agreeWithTerms.value && agreeWithProcedure.value)
  const globalIssueRequired = route.name === 'Global/IssueCreate' ? issue.value.building_id !== null : true

  return minimalRequired && globalIssueRequired
})

onMounted(() => {
  if (route.name === 'Global/IssueCreate') {
    getBuildings()
  } else {
    issueStore().getRooms()
  }
})

function getBuildings () : void {
  issueStore().levelsWithRooms = []
  issueStore().elements = []
  issue.value.room_id = null
  issue.value.element_id = null
  axios.get(process.env.VUE_APP_API_URL + '/issues/buildings').then((r) => {
    buildings.value = r.data
  })
}

function newFileUploaded (file:File) : void {
  issue.value.files.push(file)
}

function fileDeleted (index:number) : void {
  issue.value.files.splice(index, 1)
}

function buildingChanged () : void {
  issueStore().getRooms(issue.value.building_id)
  issue.value.room_id = null
  issue.value.element_id = null
}

function roomChanged () : void {
  if (route.name === 'Global/IssueCreate') {
    issueStore().getElements(issue.value.room_id, issue.value.building_id)
  } else {
    issueStore().getElements(issue.value.room_id)
  }

  issue.value.element_id = null
}

return (_ctx: any,_cache: any) => {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_select_opt_group = _resolveComponent("a-select-opt-group")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_row, { gutter: [16,16] }, {
    default: _withCtx(() => [
      (_unref(generalStore)().appSettings?.notification?.pages.includes('Service'))
        ? (_openBlock(), _createBlock(_component_a_col, {
            key: 0,
            xs: {span: 24},
            sm: {span: 24},
            md: {span: 24},
            lg: {span: 18, offset: 3}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_alert, {
                type: "info",
                class: "global-notification mb-16",
                message: _unref(generalStore)().appSettings.notification.title,
                "show-icon": ""
              }, {
                description: _withCtx(() => [
                  _createElementVNode("div", {
                    innerHTML: _unref(generalStore)().appSettings.notification.description
                  }, null, 8, _hoisted_1)
                ]),
                _: 1
              }, 8, ["message"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_a_col, {
        xs: {span: 24},
        sm: {span: 24},
        md: {span: 24},
        lg: {span: 18, offset: 3}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, { title: "Een nieuwe servicemelding maken." }, {
            extra: _withCtx(() => [
              (_unref(generalStore)().desktop && _unref(route).name !== 'Global/IssueCreate')
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'Service' })))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Terug naar servicemeldingen")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(generalStore)().desktop && _unref(route).name === 'Global/IssueCreate')
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push({ name: 'Global/Issues' })))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Terug naar overzicht")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _hoisted_2,
                      _hoisted_3,
                      _hoisted_4
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_divider),
              _hoisted_5,
              _hoisted_6,
              _createVNode(_component_a_row, { gutter: [16,16] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    xs: {span: 24},
                    sm: {span: 24},
                    md: {span: 24},
                    lg: {span: 12}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7,
                      _createVNode(_component_a_input, {
                        type: "text",
                        value: issue.value.contact_name,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((issue.value.contact_name) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: [16,16] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    xs: {span: 24},
                    sm: {span: 24},
                    md: {span: 24},
                    lg: {span: 12}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8,
                      _createVNode(_component_a_input, {
                        type: "text",
                        value: issue.value.contact_phone,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((issue.value.contact_phone) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: {span: 24},
                    sm: {span: 24},
                    md: {span: 24},
                    lg: {span: 12}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9,
                      _createVNode(_component_a_input, {
                        type: "text",
                        value: issue.value.contact_email,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((issue.value.contact_email) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_divider),
              _hoisted_10,
              (_unref(route).name === 'Global/IssueCreate')
                ? (_openBlock(), _createBlock(_component_a_row, {
                    key: 0,
                    gutter: [16,16]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        xs: {span: 24},
                        sm: {span: 24},
                        md: {span: 24},
                        lg: {span: 12}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11,
                          _createVNode(_component_a_select, {
                            style: {"width":"100%"},
                            value: issue.value.building_id,
                            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((issue.value.building_id) = $event)),
                            onChange: buildingChanged
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(buildings.value, (b) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  value: b.id,
                                  key: b.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Bouwnummer " + _toDisplayString(b.number) + " (" + _toDisplayString(b.address) + ")", 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_a_row, { gutter: [16,16] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    xs: {span: 24},
                    sm: {span: 24},
                    md: {span: 24},
                    lg: {span: 12}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12,
                      _createVNode(_component_a_select, {
                        style: {"width":"100%"},
                        value: issue.value.room_id,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((issue.value.room_id) = $event)),
                        loading: Array.isArray(_unref(issueStore)().rooms),
                        onChange: roomChanged
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(issueStore)().levelsWithRooms, (level) => {
                            return (_openBlock(), _createBlock(_component_a_select_opt_group, {
                              key: level.name
                            }, {
                              label: _withCtx(() => [
                                _createElementVNode("b", null, _toDisplayString(level.name), 1)
                              ]),
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(level.rooms, (room) => {
                                  return (_openBlock(), _createBlock(_component_a_select_option, {
                                    value: room.id,
                                    key: room.id
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(room.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value", "loading"])
                    ]),
                    _: 1
                  }),
                  (issue.value.room_id)
                    ? (_openBlock(), _createBlock(_component_a_col, {
                        key: 0,
                        xs: {span: 24},
                        sm: {span: 24},
                        md: {span: 24},
                        lg: {span: 12}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_13,
                          _createVNode(_component_a_select, {
                            style: {"width":"100%"},
                            value: issue.value.element_id,
                            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((issue.value.element_id) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(issueStore)().elements, (element) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  value: element.id,
                                  key: element.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(element.name_sales), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128)),
                              _createVNode(_component_a_select_option, { value: null }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Overige")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: [16,16] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    xs: {span: 24},
                    sm: {span: 24},
                    md: {span: 24},
                    lg: {span: 12}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14,
                      _createVNode(_component_a_input, {
                        type: "text",
                        value: issue.value.title,
                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((issue.value.title) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: [16,16] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _hoisted_15,
                      _createVNode(TextEditor, {
                        content: issue.value.body,
                        onContentChange: _cache[9] || (_cache[9] = ($event: any) => (issue.value.body = $event))
                      }, null, 8, ["content"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: [16,16] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _hoisted_16,
                      _createVNode(Uploader, { onNewFileUploaded: newFileUploaded }),
                      (issue.value.files.length)
                        ? (_openBlock(), _createBlock(UploadQueue, {
                            key: 0,
                            "media-items": issue.value.files,
                            onFileDeleted: fileDeleted
                          }, null, 8, ["media-items"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_divider),
              _hoisted_17,
              _hoisted_18,
              _createVNode(_component_a_row, { gutter: [16,16] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: agreeWithTerms.value,
                        onChange: _cache[10] || (_cache[10] = ($event: any) => (agreeWithTerms.value = !agreeWithTerms.value))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Ik/wij ga(an) akkoord met het doorgeven van mijn persoonsgegevens aan de klacht oplossende onderaannemer of leverancier & het "),
                          _hoisted_19,
                          _createTextVNode(".")
                        ]),
                        _: 1
                      }, 8, ["checked"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: agreeWithProcedure.value,
                        onChange: _cache[11] || (_cache[11] = ($event: any) => (agreeWithProcedure.value = !agreeWithProcedure.value))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Ik/wij ga(an) akkoord met "),
                          _hoisted_20,
                          _createTextVNode(" en de daarin vermelde voorwaarden. Indien de klacht niet valt onder de overeengekomen regelingen, incl. de Woningborg Garantie- en waarborgregeling, dan wordt de klacht als onterecht beoordeeld en dus ook niet in behandeling genomen. Deze voorwaarden stellen onder andere dat er bij onterecht gemelde klachten een bedrag (aan behandelings – c.q. onderzoekskosten) ad € 301,- inclusief BTW in rekening wordt gebracht. Dit bedrag wordt voor nieuwe certificaten jaarlijks aangepast conform het consumentenprijsindexcijfer (CPI) alle huishoudens van het CBS met dien verstande dat het geïndexeerde bedrag naar boven wordt afgerond op hele euro’s.")
                        ]),
                        _: 1
                      }, 8, ["checked"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, {
                class: "no-mb",
                gutter: [16,16]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _hoisted_21,
                      _createVNode(_component_a_button, {
                        type: "primary",
                        disabled: _unref(authStore)().restricted() || !_unref(requiredFieldsCompleted) || _unref(issueStore)().loading,
                        loading: _unref(issueStore)().loading,
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_unref(issueStore)().storeIssue(issue.value)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Servicemelding insturen")
                        ]),
                        _: 1
                      }, 8, ["disabled", "loading"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})